import { VStack } from '../../layouts/stack.layout';
import Heading from './heading';
import Text from './text';

type TextGroupProps = {
  heading: string;
  subheading: string;
};

export function TextGroup(props: TextGroupProps) {
  const { heading, subheading } = props;
  return (
    <VStack gap="xs">
      <Heading
        color="primary"
        casing="uppercase"
        variant="tertiary"
        text={heading}
      />
      <Text text={subheading} />
    </VStack>
  );
}
